import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { CompanyView } from '@api-proxies';
import { CompanyService } from '@http/clients/company.service';
import { TabNames } from '@models/enums/TabNames';
import { ModalConfirmComponent } from '@shared/modals/modal-confirm/modal-confirm.component';
import { EditorComponentBase, ModalService, ObjectExtensionsService } from 'ngx-lib';
import { InternalNavigatorComponent } from '../../internal-navigator/internal-navigator.component';
import { TypeAheadCompaniesComponent } from '../../type-ahead-companies/type-ahead-companies.component';

@Component({
    selector: 'app-company-editor',
    templateUrl: './company-editor.component.html',
    styleUrls: ['./company-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [InternalNavigatorComponent, TypeAheadCompaniesComponent]
})
export class CompanyEditorComponent extends EditorComponentBase<number | undefined> implements OnInit {
    selectedCompany?: CompanyView;

    editorInfoAllowAction?: boolean;

    editorInfoHasMainContactSet?: boolean;

    displaySelectedCompany: boolean;

    isActive?: boolean;

    showInternalNavigator?: boolean;

    routeToSingle?: string;

    constructor(
        private readonly companyService: CompanyService,
        private readonly modalService: ModalService,
        private readonly objectExtensionService: ObjectExtensionsService
    ) {
        super();
        this.displaySelectedCompany = true;
    }

    async ngOnInit(): Promise<void> {
        this.editorInfoAllowAction = this.additionalInfo?.allowAction;
        this.editorInfoHasMainContactSet = this.additionalInfo?.hasMainContactSet;
        this.showInternalNavigator = this.additionalInfo?.allowToNavigate;
        if (this.additionalInfo) this.isActive = this.additionalInfo.isActive;
        if (this.bindingProperty) {
            this.selectedCompany = await this.companyService.getById(this.bindingProperty);
            this.setRouteToNavigate(this.selectedCompany);
        }
    }

    async onSelectedCompany(company: CompanyView) {
        const setCompanyFn = () => {
            this.selectedCompany = company;
            this.bindingProperty = this.selectedCompany?.id;
            if (this.bindingProperty) this.setRouteToNavigate(this.selectedCompany);

            this.valueChange.emit();
        };

        if (this.editorInfoHasMainContactSet && !company) {
            const responseOk = await this.modalService.open(ModalConfirmComponent, {
                acceptCaption: 'Remove',
                cancelCaption: 'Cancel',
                content:
                    'This user is a primary contact, therefore he/she will also be removed from that section of the company.',
                title: 'Removing Company'
            });

            if (responseOk) {
                this.editorInfoHasMainContactSet = false;
                setCompanyFn();
            } else {
                this.selectedCompany = this.objectExtensionService.clone(this.selectedCompany) as CompanyView;
            }
        } else {
            setCompanyFn();
        }
    }

    setRouteToNavigate(company: CompanyView) {
        this.routeToSingle = `companies-single/${company.id}/${TabNames[TabNames.Overview]}`;
    }
}
